function getJsonDownloadSolutionsData(user_id, state_board, solution_cat, class_cat, endpoint) {
    // localStorage.removeItem("redirect_url_ref");

    var data_url = "/apps/download-solutions";
    var sub_user_id = user_id;

    var params = new URLSearchParams({
        user_id: user_id,
        state_board: state_board,
        solution_cat: solution_cat,
        class_cat: class_cat,
        endpoint: endpoint
    });

    fetch(data_url + '?' + params.toString(), {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    })
    .then(function(response) {
        if (!response.ok) {
            throw new Error('HTTP error! Status: ' + response.status);
        }

        return response.json();
    })
    .then(function(data) {

        var inner_html = "";
        var sub_solution_html = "";
        var data_length = data.length;

        const reversedKeys = Object.keys(data).reverse();

        reversedKeys.forEach(function(i) {

            var solution_name = data[i].solution_name;
            var file_src = data[i].file_src;
            var scratch_card = data[i].scratch_card;
            var isbn_number = data[i].isbn_number;
            var soluton_id = data[i].soluton_id;

            if (typeof data[i].sub_solution_data === "undefined" || data[i].sub_solution_data === null || data[i].sub_solution_data === "") {
                var sub_solution_data_length = 0;
            } else {
                var sub_solution_data = data[i].sub_solution_data;
                var sub_solution_data_length = sub_solution_data.length;
            }

            if (sub_solution_data_length > 0) {

                sub_solution_data.sort(function(a, b) {

                    var matches_a = a.solution_name.match(/\d+$/);
                    var matches_b = b.solution_name.match(/\d+$/);

                    if (matches_a && matches_b) {
                        return parseInt(matches_a[0]) - parseInt(matches_b[0]);
                    } else {
                        return 0;
                    }

                });

                sub_solution_html =
                    '<ul class="sub-solution-list hide" id="sub-solution-list-' +
                    soluton_id +
                    '">';

                var has_sub_solution = "has_sub_solution down-arrow";

                var open_sub_solution_fnc =
                    'open_sub_solution_fnc(' + soluton_id + ')';

                for (var s = 0; s < sub_solution_data_length; s++) {

                    var sub_solution_id = sub_solution_data[s].id;
                    var sub_solution_name = sub_solution_data[s].solution_name;
                    var sub_isbn_number = sub_solution_data[s].isbn_number;

                    var get_sub_solution_file =
                        'get_sub_solution_file(' +
                        sub_solution_id +
                        ', \'' +
                        sub_isbn_number +
                        '\', ' +
                        sub_user_id +
                        ')';

                    sub_solution_html +=
                        '<li class="sub-solution-link">' +
                            '<a href="javascript:void(0);" onclick="' +
                            get_sub_solution_file +
                            '">' +
                            sub_solution_name +
                            '</a>' +
                        '</li>';
                }

                sub_solution_html += '</ul>';

            } else {

                var has_sub_solution = "no_sub_solution";
                var sub_solution_html = "";

                var open_sub_solution_fnc =
                    'get_solution_file(' +
                    soluton_id +
                    ', \'' +
                    isbn_number +
                    '\', ' +
                    user_id +
                    ')';
            }

            inner_html +=
                '<li style="cursor: pointer;" class="mh-togglelink-sml" onclick="' +
                open_sub_solution_fnc +
                '">' +

                    '<a class="' +
                    has_sub_solution +
                    '" href="javascript:void(0);">' +

                        '<span class="mh-filebg">' +
                            '<img class="mh-pdfimg lazyload hs-lazyload hs-id-89fe87ad" ' +
                            'data-src="{{ \'mh-pdf.png\' | asset_img_url: \'100px\' }}" ' +
                            'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==">' +
                        '</span>' +

                        solution_name +
                        '<p>' +
                        isbn_number +
                        '</p>' +

                    '</a>' +

                    sub_solution_html +

                '</li>';
        });

        var setResult = document.getElementById('set_result');

        if (setResult) {

            if (inner_html !== "") {
                setResult.innerHTML = inner_html;
            } else {
                setResult.innerHTML = "No material found!";
            }

        }

    })
    .catch(function(error) {
        console.error('Error fetching solutions:', error);
    });
}


function open_sub_solution_fnc(sol_id) {

    var subSolutionList =
        document.getElementById("sub-solution-list-" + sol_id);

    if (!subSolutionList) {
        return;
    }

    /*
     * jQuery original:
     * $("#sub-solution-list-"+sol_id).toggleClass("hide show");
     */

    if (subSolutionList.classList.contains('hide')) {

        subSolutionList.classList.remove('hide');
        subSolutionList.classList.add('show');

    } else {

        subSolutionList.classList.remove('show');
        subSolutionList.classList.add('hide');

    }


    /*
     * jQuery original:
     * $("#sub-solution-list-"+sol_id)
     *     .prev(".has_sub_solution")
     *     .toggleClass("down-arrow up-arrow");
     */

    var previousElement = subSolutionList.previousElementSibling;

    if (
        previousElement &&
        previousElement.classList.contains('has_sub_solution')
    ) {

        if (previousElement.classList.contains('down-arrow')) {

            previousElement.classList.remove('down-arrow');
            previousElement.classList.add('up-arrow');

        } else {

            previousElement.classList.remove('up-arrow');
            previousElement.classList.add('down-arrow');

        }
    }
}


function open_sub_solution_fnc_global(sol_id, user_id) {

    var data_url = "/apps/download-solutions";

    var subSolutionList =
        document.getElementById("sub-solution-list-" + sol_id);

    /*
     * Equivalent of jQuery beforeSend()
     */

    if (subSolutionList) {
        subSolutionList.innerHTML = "<li>Loading...</li>";
    }

    var formData = new URLSearchParams();

    formData.append('sol_id', sol_id);
    formData.append('user_id', user_id);
    formData.append('endpoint', 'sub_solution_list_gen');


    fetch(data_url, {
        method: 'POST',

        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'application/json'
        },

        body: formData.toString()
    })
    .then(function(response) {

        if (!response.ok) {
            throw new Error('HTTP error! Status: ' + response.status);
        }

        return response.json();
    })
    .then(function(sub_solution_data) {

        var sub_solution_html = "";

        for (var s = 0; s < sub_solution_data.length; s++) {

            var sub_solution_id =
                sub_solution_data[s].sub_solution_id;

            var sub_solution_name =
                sub_solution_data[s].sub_solution_name;

            var sub_isbn_number =
                sub_solution_data[s].sub_isbn_number;

            var sub_user_id =
                sub_solution_data[s].sub_user_id;


            var get_sub_solution_file =
                'get_sub_solution_file(' +
                sub_solution_id +
                ', \'' +
                sub_isbn_number +
                '\', ' +
                sub_user_id +
                ')';


            sub_solution_html +=
                '<li class="sub-solution-link">' +
                    '<a href="javascript:void(0);" onclick="' +
                    get_sub_solution_file +
                    '">' +
                    sub_solution_name +
                    '</a>' +
                '</li>';
        }


        if (subSolutionList) {
            subSolutionList.innerHTML = sub_solution_html;
        }

    })
    .catch(function(error) {

        console.error('Error fetching sub solutions:', error);

        if (subSolutionList) {
            subSolutionList.innerHTML =
                "<li>Unable to load solutions.</li>";
        }

    });
}


function get_solution_file(sol_id, isbn, user_id) {

    var data_url =
        "/apps/download-solutions";

    if (typeof user_id === "undefined" || user_id === null || user_id === "") {


        var solurl =
            '/pages/get-solution/?isbn=' +
            isbn +
            ',' +
            sol_id +
            ',get_solution_file';


        // window.open(
        //     '/account/login?redirect_url=' + solurl,
        //     '_blank'
        // );

        window.location.href =
            '/customer_authentication/login?return_to=' +
            encodeURIComponent(solurl);

    } else {

        /*
         * Add loading indicator
         */

        var setResult =
            document.getElementById('set_result');

        if (setResult) {

            setResult.insertAdjacentHTML(
                'beforeend',
                '<div style="" id="loadingDiv">' +
                    '<div class="loader">Loading...</div>' +
                '</div>'
            );
        }


        var formData = new URLSearchParams();

        formData.append('user_id', user_id);
        formData.append('isbn', isbn);
        formData.append('sol_id', sol_id);
        formData.append('endpoint', 'get_solution_file');


        fetch(data_url, {

            method: 'POST',

            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',

                'Accept': 'application/json'
            },

            body: formData.toString()

        })
        .then(function(response) {

            if (!response.ok) {
                throw new Error(
                    'HTTP error! Status: ' +
                    response.status
                );
            }

            return response.json();

        })
        .then(function(data) {

            if (
                data.proceed_url &&
                data.proceed_url.trim() !== ""
            ) {

                if (user_id == '5666933113012') {

                    window.open(
                        data.proceed_url_new,
                        '_blank'
                    );

                } else {

                    window.open(
                        data.proceed_url_new,
                        '_blank'
                    );

                }

            } else {

                alert(
                    "Downloadable file not found! " +
                    "Contact us for further solution."
                );

            }

        })
        .catch(function(error) {

            console.error(
                'Error downloading solution:',
                error
            );

        })
        .finally(function() {

            var loadingDiv =
                document.getElementById('loadingDiv');

            if (loadingDiv) {
                loadingDiv.remove();
            }

        });
    }
}


function get_sub_solution_file(
    sub_sol_id,
    sub_isbn,
    sub_user_id
) {

    var data_url =
        "/apps/download-solutions";



    if (typeof sub_user_id === "undefined" || sub_user_id === null || sub_user_id === "") {

        var subsolurl =
            '/pages/get-solution/?isbn=' +
            sub_isbn +
            ',' +
            sub_sol_id +
            ',get_sub_solution_file';


        // window.open(
        //     '/account/login?redirect_url=' + subsolurl,
        //     '_blank'
        // );

        window.location.href =
            '/customer_authentication/login?return_to=' +
            encodeURIComponent(subsolurl);

    } else {

        /*
         * Add loading indicator
         */

        var setResult =
            document.getElementById('set_result');

        if (setResult) {

            setResult.insertAdjacentHTML(
                'beforeend',
                '<div style="" id="loadingDiv">' +
                    '<div class="loader">Loading...</div>' +
                '</div>'
            );

        }


        var formData = new URLSearchParams();

        formData.append(
            'sub_user_id',
            sub_user_id
        );

        formData.append(
            'sub_isbn',
            sub_isbn
        );

        formData.append(
            'sub_sol_id',
            sub_sol_id
        );

        formData.append(
            'endpoint',
            'get_sub_solution_file'
        );


        fetch(data_url, {

            method: 'POST',

            headers: {

                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',

                'Accept':
                    'application/json'

            },

            body: formData.toString()

        })
        .then(function(response) {

            if (!response.ok) {

                throw new Error(
                    'HTTP error! Status: ' +
                    response.status
                );

            }

            return response.json();

        })
        .then(function(data) {

            if (
                data.proceed_url &&
                data.proceed_url.trim() !== ""
            ) {

                if (
                    sub_user_id ==
                    '5666933113012'
                ) {

                    window.open(
                        data.proceed_url_new,
                        '_blank'
                    );

                } else {

                    window.open(
                        data.proceed_url_new,
                        '_blank'
                    );

                }

            } else {

                alert(
                    "Downloadable file not found! " +
                    "Contact us for further solution."
                );

            }

        })
        .catch(function(error) {

            console.error(
                'Error downloading sub solution:',
                error
            );

        })
        .finally(function() {

            var loadingDiv =
                document.getElementById(
                    'loadingDiv'
                );

            if (loadingDiv) {
                loadingDiv.remove();
            }

        });
    }
}